import { SVGProps } from 'react';

export const SPayIcon = ({
  width = 167,
  height = 68,
  ...rest
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 167 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_33356_42067)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.373 53.1075V12.9763C74.373 12.1437 75.047 11.4697 75.8796 11.4697H89.4304C97.0582 11.5688 103.265 17.7813 103.265 25.3179C103.265 32.8545 97.0562 39.067 89.4245 39.1661H79.6221V53.1055C79.6221 53.938 78.9481 54.612 78.1156 54.612H75.8796C75.047 54.612 74.373 53.938 74.373 53.1055V53.1075ZM79.6201 33.7129H89.367C91.6506 33.7129 93.7974 32.8288 95.411 31.2211C97.0245 29.6155 97.9126 27.4826 97.9126 25.2148C97.9126 20.5287 94.0888 16.7188 89.3908 16.7188H79.6201V33.7129Z"
        fill="#EE4D2D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.811 66.6424L148.069 49.0179L135.785 28.9097C135.416 28.3071 135.85 27.536 136.556 27.536H141.529L151.409 43.5587L160.95 27.536H165.539C166.238 27.536 166.673 28.2972 166.316 28.8998L143.196 68.0022H138.592C137.894 68.0022 137.46 67.2469 137.811 66.6443V66.6424Z"
        fill="#EE4D2D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.272 52.9013V50.584L125.509 51.2183C123.039 53.2739 119.881 54.4058 116.623 54.4058C109.096 54.4058 102.973 48.3777 102.973 40.9699C102.973 33.5622 109.096 27.7402 116.623 27.7402C119.883 27.7402 123.039 28.8721 125.509 30.9297L126.272 31.564V29.2468C126.272 28.4142 126.946 27.7402 127.779 27.7402H130.903V54.4058H127.779C126.946 54.4058 126.272 53.7318 126.272 52.8993V52.9013ZM116.585 32.7435C111.855 32.7435 108.006 36.4404 108.006 40.9858C108.006 45.5312 111.935 49.4303 116.585 49.4303C121.235 49.4303 125.164 45.5629 125.164 40.9858C125.164 36.4087 121.315 32.7435 116.585 32.7435Z"
        fill="#EE4D2D"
      />
      <path
        d="M54.1161 11.3902H8.69823C7.3146 11.3902 6.19263 10.2682 6.19263 8.88461C6.19263 8.25622 6.70208 7.74678 7.33046 7.74678H48.0325C48.6609 7.74678 49.1704 7.23734 49.1704 6.60895V2.50564C49.1704 1.03479 47.9096 -0.118892 46.4447 0.00995644L5.20149 3.6514C2.25979 3.90711 0 6.37108 0 9.32467V48.9682C0 52.1121 2.54921 54.6613 5.6931 54.6613H54.1142C57.258 54.6613 59.8073 52.1121 59.8073 48.9682V17.0853C59.8073 13.9414 57.258 11.3922 54.1142 11.3922"
        fill="#EE4D2D"
      />
      <path
        d="M40.083 41.1758C39.7242 44.1115 37.9342 46.4625 35.159 47.64C33.6148 48.2961 31.5453 48.647 29.904 48.536C27.3528 48.4388 24.9542 47.8223 22.744 46.6944C21.9392 46.2841 20.7597 45.4733 19.8717 44.732C19.6695 44.5635 19.5644 44.4128 19.7607 44.1393C19.9688 43.8281 20.7895 42.6407 20.9203 42.4444C21.0948 42.1788 21.3822 42.1649 21.6458 42.3711C21.6815 42.3988 21.9491 42.607 22.0026 42.6466C24.1296 44.3018 26.8731 45.5447 29.9238 45.6597C33.7694 45.6081 36.5585 43.8955 37.056 41.2432C37.6051 38.3213 35.274 35.8137 30.7821 34.4162C29.3549 33.9722 25.765 32.543 25.1009 32.1584C21.9729 30.3347 20.5139 27.9441 20.7221 25.0004C21.0393 20.9209 24.8472 17.8642 29.68 17.8444C31.9735 17.8404 34.1243 18.3439 36.0411 19.1467C36.7468 19.4421 38.0611 20.1458 38.5289 20.4927C38.8559 20.7306 38.8302 20.9982 38.7013 21.2063C38.511 21.5235 37.9421 22.4076 37.7142 22.7743C37.5476 23.0261 37.3415 23.0558 37.0461 22.8714C34.5742 21.2222 32.033 20.6632 29.7454 20.6176C26.4449 20.683 23.9552 22.6296 23.7926 25.3017C23.749 27.7141 25.5945 29.4645 29.5135 30.8025C37.6031 33.3834 40.6658 36.4183 40.085 41.1738"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_33356_42067">
        <rect width="166.442" height="68" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
